import { viewSchemas } from "@redotech/redo-views-common/views";
import * as z from "zod";

export const saveConsolidationView = {
  name: "saveConsolidationView" as const,
  input: z.object({ view: viewSchemas.consolidations }),
  output: z.object({}),
};
